import { thumbnails } from "./assets";
import { PLAYTIME_PHASE } from "./constants";

const { LOGIN, EXPLORE, KEEPGOING } = PLAYTIME_PHASE;

/** @todo update region routes to specific one-click region routes */
const gameplayByRegion = {
  dreamspace: {
    [LOGIN]: "#ocCharacterCustomization",
    [EXPLORE]: "#region/2yEUZZIs7G8kbi62zHK3",
    [KEEPGOING]: "#shortcut/2yEUZZIs7G8kbi62zHK3",
  },
  caves: {
    [EXPLORE]: "#ocp/GoEiu5mQNUtJ1IoqDHp6",
    [KEEPGOING]: "#shortcut/5ZZEV28ul2WnnQW2arxH",
  },
  arctic: {
    [EXPLORE]: "#ocp/uAxT54weBukBrlf76MCL",
    [KEEPGOING]: "#shortcut/qpy4jMcs23derdyB4keq",
  },
  ruins: {
    [EXPLORE]: "#ocp/5g8pNeYBVc7EAuWwhQUA",
    [KEEPGOING]: "#shortcut/qP80NwekYfZgwdalc3ey",
  },
  underwater: {
    [EXPLORE]: "#ocp/14MI8lUcbBPCxHTCgfqb",
    [KEEPGOING]: "#shortcut/Wr5ydOu2b8knIPZH7bFH",
  },
  beach: {
    [EXPLORE]: "#ocp/Dv5SQfzgiEn301NuBP1Z",
    [KEEPGOING]: "#shortcut/Tfth8jJQphFxtPzRFugL",
  },
  town: {
    [EXPLORE]: "#ocp/JuaXRNhp4qHgLUTXOCFR",
    [KEEPGOING]: "#shortcut/gwzs9wDHIJlby9wdWrKF",
  },
  outskirts: {
    [EXPLORE]: "#ocp/D6BvielGITXYtkJwJEjW",
    [KEEPGOING]: "#shortcut/i8wmhxya9qt4IbFzZndw",
  },
  station: {
    [KEEPGOING]: "#shortcut/fEDtj1RV0uMfya1onBjm",
  },
  hq: {
    [KEEPGOING]: "#shortcut/51yrkqc5VtyL8xdSIWzI",
  },
};

// Lesson 01 does not have discuss timers
const LESSON_01_TIMER_TIMES = {
  [LOGIN]: 5,
  [EXPLORE]: 3,
  [KEEPGOING]: 25,
};

// Used for L09 and L10
const EXTENDED_KEEPGOING_TIMER_TIME = {
  [KEEPGOING]: 35,
};

const launchPlaylistData = {
  // note: video data uses Bunny Stream video ids
  rewritersLesson01: {
    id: "rewritersLesson01",
    data: {
      timerTimes: LESSON_01_TIMER_TIMES,
      gameplay: gameplayByRegion.dreamspace,
      polls: {
        pushbubble: {
          pollId: "pushbubble",
          question: "Why couldn’t Sol push the bubble?",
          choices: [
            {
              choiceId: "1",
              text: "There is no rule that says the bubble can be pushed",
            },
            { choiceId: "2", text: "Sol got trapped in the bubble" },
            { choiceId: "3", text: "Bubbles always pop when pushed" },
            { choiceId: "4", text: "Sol can only push crabs" },
          ],
          correctChoiceId: "1",
        },
      },
      video: {
        explain1: "c78b9e98-701b-4a1c-8752-a5846716d744",
        explain2: "d0646816-8b2b-441d-98b3-a7cb692fe49c",
      },
      slides:
        "https://9dots.slides.com/alexiscabrera/rewriters-lesson-1/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.launch01,
      lessonNum: 1,
    },
  },
  rewritersLesson02: {
    id: "rewritersLesson02",
    data: {
      gameplay: gameplayByRegion.caves,
      polls: {
        helpful: {
          pollId: "helpful",
          question: "Which rule(s) are helpful for solving the problem?",
          choices: [
            {
              choiceId: "1",
              text: "SOL IS SINK",
              image: ["text_verdad", "text_is", "text_sink"],
            },
            {
              choiceId: "2",
              text: "FOSSIL IS SINK",
              image: ["text_fossil", "text_is", "text_sink"],
            },
            {
              choiceId: "3",
              text: "GOLD IS SINK",
              image: ["text_topaz", "text_is", "text_sink"],
            },
            {
              choiceId: "4",
              text: "Both 2 and 3",
            },
          ],
          correctChoiceId: "4",
        },
        spikes: {
          pollId: "spikes",
          question:
            "Which state block would you use on the CRYSTALS to make this happen?",
          choices: [
            { choiceId: "1", text: "WEAK", image: "text_weak" },
            { choiceId: "2", text: "BOOM", image: "text_boom" },
            { choiceId: "3", text: "SINK", image: "text_sink" },
          ],
          correctChoiceId: "1",
        },
        fossils: {
          pollId: "fossils",
          question:
            "Which state block would you use on the FOSSILS to make this happen?",
          choices: [
            { choiceId: "1", text: "WEAK", image: "text_weak" },
            { choiceId: "2", text: "BOOM", image: "text_boom" },
            { choiceId: "3", text: "SINK", image: "text_sink" },
          ],
          correctChoiceId: "2",
        },
      },
      video: {
        explain1: "43a2caaa-3643-4038-bb1f-108314e5a494",
        explain2: "fdaf8a3e-c726-4b0e-a34e-5e2f132b0e28",
      },
      slides:
        "https://9dots.slides.com/alexiscabrera/rewriters-lesson-2/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.launch02,
      lessonNum: 2,
    },
  },
  rewritersLesson03: {
    id: "rewritersLesson03",
    data: {
      gameplay: gameplayByRegion.arctic,
      polls: {
        observation: {
          pollId: "observation",
          question: "Which of Zorro's observations is the most useful?",
          choices: [
            { choiceId: "1", text: "The lava is orange" },
            { choiceId: "2", text: "There's a lot of snow" },
            { choiceId: "3", text: "There's a rule for ROCK IS DEFEAT" },
            { choiceId: "4", text: "Walking on lava seems scary" },
          ],
          correctChoiceId: "3",
        },
      },
      video: {
        explain1: "4736edb9-2f5d-41d4-aa3e-47405c640108",
        explain2: "a5daf165-6c3b-4ef9-9863-d461c781df06",
      },
      slides:
        "https://9dots.slides.com/alexiscabrera/rewriters-lesson-3/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.launch03,
      lessonNum: 3,
    },
  },
  rewritersLesson04: {
    id: "rewritersLesson04",
    data: {
      gameplay: gameplayByRegion.ruins,
      polls: {
        blocking: {
          pollId: "blocking",
          question: "In problem 1, what's blocking you from the goal and why?",
          choices: [
            { choiceId: "1", text: "Grass, because GRASS IS SHUT" },
            { choiceId: "2", text: "Water, because WATER IS STOP" },
            { choiceId: "3", text: "Water, because WATER IS SHUT" },
          ],
          correctChoiceId: "2",
        },
        frogstates: {
          pollId: "frogstates",
          question: "Which state blocks will help us get past the flower?",
          choices: [
            {
              choiceId: "1",
              text: "OPEN and SHUT",
              image: ["text_open", "text_and", "text_shut"],
            },
            {
              choiceId: "2",
              text: "OPEN and PUSH",
              image: ["text_open", "text_and", "text_push"],
            },
            {
              choiceId: "3",
              text: "SHUT and PUSH",
              image: ["text_shut", "text_and", "text_push"],
            },
          ],
          correctChoiceId: "3",
        },
      },
      video: {
        explain1: "d017a8ae-4ea5-45d0-ac4b-18ad2f9cf799",
        explain2: "38bb8616-3ba3-498b-94f2-b561f26987c9",
      },
      slides:
        "https://9dots.slides.com/alexiscabrera/rewriters-lesson-4/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.launch04,
      lessonNum: 4,
    },
  },
  rewritersLesson05: {
    id: "rewritersLesson05",
    data: {
      gameplay: gameplayByRegion.underwater,
      polls: {
        chamber: {
          pollId: "chamber",
          question:
            "In problem 1, who's correct about which chamber you want to enter first and why?",
          choices: [
            { choiceId: "1", text: "MOREL", image: "morel" },
            { choiceId: "2", text: "ZORRO", image: "zorro" },
            { choiceId: "3", text: "ENOKI", image: "enoki" },
            { choiceId: "4", text: "OLIVE", image: "olive" },
          ],
          correctChoiceId: "3",
        },
        steps: {
          pollId: "steps",
          question: "What steps do the Rewriters need to do in this chamber?",
          choices: [
            {
              choiceId: "1",
              text: "Make HEART IS WIN",
            },
            {
              choiceId: "2",
              text: "Get past the crabs",
            },
            {
              choiceId: "3",
              text: "Get the 2 starfish",
            },
            {
              choiceId: "4",
              text: "All of the above",
            },
          ],
          correctChoiceId: "4",
        },
      },
      video: {
        explain1: "d478c4f7-0aae-437d-a710-0b7d2268db32",
        explain2: "ad7f5066-9a2b-4890-9cef-1eea1b65d4c2",
      },
      slides:
        "https://9dots.slides.com/alexiscabrera/rewriters-lesson-5/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.launch05,
      lessonNum: 5,
    },
  },
  rewritersLesson06: {
    id: "rewritersLesson06",
    data: {
      gameplay: gameplayByRegion.beach,
      polls: {
        firstrule: {
          pollId: "firstrule",
          question: "Which rule should Sol and Olive write first?",
          choices: [
            {
              choiceId: "1",
              text: "CLAM IS CRAB",
              image: ["text_clam", "text_is", "text_crabcowboy"],
            },
            {
              choiceId: "2",
              text: "CLAM IS STARFISH",
              image: ["text_clam", "text_is", "text_star"],
            },
            {
              choiceId: "3",
              text: "STARFISH IS CRAB",
              image: ["text_star", "text_is", "text_crabcowboy"],
            },
          ],
          correctChoiceId: "2",
        },
        heart: {
          pollId: "heart",
          question: "Which rule would transform the crab into a heart?",
          choices: [
            {
              choiceId: "1",
              text: "HEART IS CRAB",
              image: ["text_heart", "text_is", "text_crabcowboy"],
            },
            {
              choiceId: "2",
              text: "CRAB IS HEART",
              image: ["text_crabcowboy", "text_is", "text_heart"],
            },
            {
              choiceId: "3",
              text: `The order of the rule doesn't matter`,
            },
          ],
          correctChoiceId: "2",
        },
      },
      video: {
        explain1: "681788ce-69b1-403f-b421-abb290fe5669",
        explain2: "b7949217-44f4-4d30-aa4e-67afb7c016f4",
      },
      slides:
        "https://9dots.slides.com/alexiscabrera/rewriters-lesson-6/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.launch06,
      lessonNum: 6,
    },
  },
  rewritersLesson07: {
    id: "rewritersLesson07",
    data: {
      gameplay: gameplayByRegion.town,
      polls: {
        revise: {
          pollId: "revise",
          question: "How should the Rewriters revise their plan?",
          choices: [
            {
              choiceId: "1",
              text: "Make GRASS IS SAFE",
            },
            {
              choiceId: "2",
              text: "Make BOX IS SAFE",
            },
            {
              choiceId: "3",
              text: "Push SAFE block into grass",
            },
          ],
          correctChoiceId: "2",
        },
      },
      video: {
        explain1: "fdf353d6-43b4-49e1-ad59-beb0d0241fd9",
        explain2: "7509b45d-974d-445b-a62c-e9a83f6d1e5f",
      },
      slides:
        "https://9dots.slides.com/alexiscabrera/rewriters-lesson-7/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.launch07,
      lessonNum: 7,
    },
  },
  rewritersLesson08: {
    id: "rewritersLesson08",
    data: {
      gameplay: gameplayByRegion.outskirts,
      polls: {
        pushfrog: {
          pollId: "pushfrog",
          question: `The Rewriters plan to push the frog into the water. Why doesn't that plan work?`,
          choices: [
            {
              choiceId: "1",
              text: `The frog can't be pushed`,
            },
            {
              choiceId: "2",
              text: `The water won't sink`,
            },
            {
              choiceId: "3",
              text: `There aren't enough frogs`,
            },
            {
              choiceId: "4",
              text: `All of the above`,
            },
          ],
          correctChoiceId: "4",
        },
      },
      video: {
        explain1: "c2eb79b6-4fb5-4641-92b4-42ae25774698",
        explain2: "f9a51387-ebaf-4561-b85d-dca897194f05",
      },
      slides:
        "https://9dots.slides.com/alexiscabrera/rewriters-lesson-8/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.launch08,
      lessonNum: 8,
    },
  },
  rewritersLesson09: {
    id: "rewritersLesson09",
    data: {
      timerTimes: EXTENDED_KEEPGOING_TIMER_TIME,
      gameplay: gameplayByRegion.station,
      polls: {
        hotmelt: {
          pollId: "hotmelt",
          question:
            "After Sol writes ICE IS HOT, which object(s) will be destroyed?",
          choices: [
            {
              choiceId: "1",
              text: "HEART",
            },
            {
              choiceId: "2",
              text: "SNOWBEAR",
            },
            {
              choiceId: "3",
              text: "BOTH",
            },
          ],
          correctChoiceId: "1",
        },
        openshut: {
          pollId: "openshut",
          question:
            "If Sol pushes the frog into the fly, which object(s) will disappear?",
          choices: [
            {
              choiceId: "1",
              text: "FROG",
            },
            {
              choiceId: "2",
              text: "FLY",
            },
            {
              choiceId: "3",
              text: "BOTH",
            },
          ],
          correctChoiceId: "3",
        },
      },
      video: {
        explain1: "523a1ece-3a3a-4efc-8684-129f812895d5",
        explain2: "d36f6494-068e-4503-ab3e-c9718d7272af",
        explain3: "576ac63d-6b8a-4bce-834e-a01fa4a08229",
      },
      slides:
        "https://9dots.slides.com/alexiscabrera/rewriters-lesson-9/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.launch09,
      lessonNum: 9,
    },
  },
  rewritersLesson10: {
    id: "rewritersLesson10",
    data: {
      timerTimes: EXTENDED_KEEPGOING_TIMER_TIME,
      gameplay: gameplayByRegion.hq,
      video: {
        checkin1: "2e0dac45-75ca-47b4-a4bb-de958350bb62",
        checkin2: "b5801a71-5a6c-4da1-8e36-5f0b2627e283",
      },
      slides:
        "https://9dots.slides.com/alexiscabrera/rewriters-lesson-10/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.launch10,
      lessonNum: 10,
    },
  },
};

const softLaunchPlaylistData = Object.entries(launchPlaylistData).reduce(
  (dataAcc, [key, value]) => {
    const newKey = key.replace("rewritersLesson", "softlaunch");
    dataAcc[newKey] = {
      ...value,
      id: newKey,
    };
    return dataAcc;
  },
  {}
);

/** @todo longterm - save data as json */
export const playlistData = {
  publicPreview: {
    ...launchPlaylistData.rewritersLesson01,
    id: "publicPreview",
  },
  tutorial: {
    display: 0,
    id: "tutorial",
    name: "Lesson 0",
    sequence: "onboarding",
    data: {
      /** @todo remove playlist property */
      playlist: {
        0: {
          display: 0,
          label: "",
          puzzles: {
            1: "XluB96ZEgKt2Oa2oYxUU",
            2: "QdmV0K8k7GlZaquZ5obJ",
            3: "53dLJeKpoXenbHNzwHA4",
            4: "IR0iRjJadRRKExuAKsl2",
            5: "uqeNDFLE6JaHZAgF4vGn",
            6: "juc2OAeeGrg1KbfpX8M3",
            7: "A0a5nf5jgKBlYRHGlPPc",
            8: "A5YUITJPekEi5S1VfmFM",
            9: "vj2wJGIEBn7AZcBynHZZ",
          },
        },
      },
    },
  },
  ...softLaunchPlaylistData,
  ...launchPlaylistData,
};
